export * from 'src/app/@theme/layouts/menu/vertical-menu/vertical-menu.component';
export * from 'src/app/@theme/layouts/menu/vertical-menu/vertical-menu.module';
